export type DirectionType = {
  title: string;
  description: string;
  image: string;
}

export const DIRECTIONS: DirectionType[] = [
  {
    title: "directions.0.title",
    description: "directions.0.description",
    image: "platform",
  },
  {
    title: "directions.1.title",
    description: "directions.1.description",
    image: "webinar",
  },
  {
    title: "directions.2.title",
    description: "directions.2.description",
    image: "education",
  },
  {
    title: "directions.3.title",
    description: "directions.3.description",
    image: "talents",
  },
  {
    title: "directions.4.title",
    description: "directions.4.description",
    image: "leaders",
  },
  {
    title: "directions.5.title",
    description: "directions.5.description",
    image: "coach",
  },
]
